export default __webpack_public_path__ + "static/media/person-icon.c58246e7.svg";